module.exports = __webpack_public_path__ + "static/images/callout_2.9a65c2ca89967b458409bb2545be86d1.jpg";